import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTooltip } from '../hooks';

/**
 * Wrapper around react-router-dom's Link that adds tooltip support.
 * @param {object} props - All Link props, plus an optional `tooltip` string.
 * @param {string} [props.tooltip] - Text to display in the tooltip on hover.
 */
export const Link = props => {
  const { showTooltip, hideTooltip } = useTooltip();

  const tooltip = props.tooltip;
  const children = props.children;

  return (
    <RouterLink
      {...props}
      onMouseEnter={() => tooltip && showTooltip({ title: tooltip })}
      onMouseLeave={hideTooltip}
    >
      {children}
    </RouterLink>
  );
};
